// ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("access"); // backend se aane wala token
  return token ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
